
import { motion } from 'framer-motion';
import { Film, Star, Play } from 'lucide-react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'cinema' | 'stars' | 'film';
}

const Loader = ({ size = 'md', variant = 'cinema' }: LoaderProps) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-16 h-16',
    lg: 'w-24 h-24'
  };

  if (variant === 'cinema') {
    return (
      <div className="flex items-center justify-center">
        <motion.div
          className={`${sizeClasses[size]} relative`}
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
        >
          <div className="absolute inset-0 border-4 border-amber-400/20 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-amber-400 rounded-full"></div>
          <div className="absolute inset-2 bg-gradient-to-br from-amber-400/20 to-blue-500/20 rounded-full flex items-center justify-center">
            <Film className="w-1/2 h-1/2 text-amber-400" />
          </div>
        </motion.div>
      </div>
    );
  }

  if (variant === 'stars') {
    return (
      <div className="flex items-center justify-center space-x-2">
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            animate={{ scale: [1, 1.5, 1], opacity: [0.5, 1, 0.5] }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: i * 0.2,
              ease: 'easeInOut'
            }}
          >
            <Star className="w-6 h-6 text-amber-400 fill-amber-400" />
          </motion.div>
        ))}
      </div>
    );
  }

  if (variant === 'film') {
    return (
      <div className="flex items-center justify-center">
        <motion.div
          className="relative"
          animate={{ rotateY: [0, 180, 360] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        >
          <div className="w-16 h-12 bg-gradient-to-r from-amber-400 to-blue-500 rounded-lg opacity-20"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Play className="w-6 h-6 text-amber-400" />
          </div>
          <div className="absolute -left-2 top-1 w-2 h-2 bg-amber-400 rounded-full"></div>
          <div className="absolute -left-2 top-4 w-2 h-2 bg-amber-400 rounded-full"></div>
          <div className="absolute -left-2 top-7 w-2 h-2 bg-amber-400 rounded-full"></div>
          <div className="absolute -right-2 top-1 w-2 h-2 bg-amber-400 rounded-full"></div>
          <div className="absolute -right-2 top-4 w-2 h-2 bg-amber-400 rounded-full"></div>
          <div className="absolute -right-2 top-7 w-2 h-2 bg-amber-400 rounded-full"></div>
        </motion.div>
      </div>
    );
  }

  return null;
};

export default Loader;
